import { useState, useEffect } from 'react';
import { accountsService } from '@/services/api/api';

function useDropdownData() {
  const [organizations, setOrganizations] = useState([]);
  const [organizationalUnits, setOrganizationalUnits] = useState([]);
  const [types, setTypes] = useState([]);
  const [opcos, setOpcos] = useState([]);
  const [domains, setDomains] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadDropdownData = async () => {
      try {
        setLoading(true);
        setError(null);

        const [opcosRes, typesRes, domainsRes, organizationsRes, contactsRes, costCentersRes, groupsRes, organizationalUnitsRes] = await Promise.all([
          accountsService.getOpcos(),
          accountsService.getTypes(),
          accountsService.getDomains(),
          accountsService.getOrganizations(),
          accountsService.getContacts(),
          accountsService.getCostCenters(),
          accountsService.getGroups(),
          accountsService.getFromDatabase('AWSOrganizationalUnits'),
        ]);
        setOrganizations(organizationsRes.data || []);
        setOrganizationalUnits(organizationalUnitsRes.data || []);
        setOpcos(opcosRes.data || []);
        setTypes(typesRes.data || []);
        setDomains(domainsRes.data || []);
        setContacts(contactsRes.data || []);
        setCostCenters(costCentersRes.data || []);
        setGroups(groupsRes.data || []);
      } catch (error) {
        setError('Error loading form data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    loadDropdownData();
  }, []);

  const refreshContacts = async () => {
    try {
      const contactsRes = await accountsService.getContacts();
      setContacts(contactsRes.data || []);
    } catch (error) {
      console.error('Error refreshing contacts:', error);
    }
  };

  const refreshCostCenters = async () => {
    try {
      const costCentersRes = await accountsService.getCostCenters();
      setCostCenters(costCentersRes.data || []);
    } catch (error) {
      console.error('Error refreshing cost centers:', error);
    }
  };

  return {
    organizations,
    organizationalUnits,
    types,
    opcos,
    domains,
    contacts,
    costCenters,
    groups,
    loading,
    error,
    refreshContacts,
    refreshCostCenters
  };
}

export default useDropdownData; 